<template>
  <div class="selectCustomerStyle">
    <v-autocomplete
      v-model="inputedValue"
      item-text="label"
      item-value="value"
      :items="this.getCustomerIdNameListFromState()"
      dense
      outlined
      return-object
      class="original-selectbox"
      hide-details
      :placeholder="$t('common.input_unselected_2')"
      :height="height"
      clearable
      width="80%"
      :disabled="disabled"
      :filled="disabled"
      :no-data-text="$t('common.common_no-data')"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  components: {
    //
  },
  props: {
    value: {
      type: Object,
      require: false,
      default: () => ({})
    },
    height: {
      type: String,
      require: false,
      default: '32px'
    },
    disabled: { default: false }
  },
  data: () => ({
    items: []
  }),
  created() {},
  methods: {
    ...mapGetters('Customer', ['getCustomerIdNameListFromState'])
  },
  computed: {
    inputedValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    }
  }
}
</script>
<style scoped lang="scss">
.selectCustomerStyle {
  width: 100%;
}
</style>
